import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const Finance = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/cashier`}/>
            <Route path={`${match.url}/cashier`} component={asyncComponent(() => import('./routes/Cashier'))}/>
            <Route path={`${match.url}/self-billing`} component={asyncComponent(() => import('./routes/SelfBilling'))}/>
            <Route path={`${match.url}/invoice`} component={asyncComponent(() => import('./routes/Invoice'))}/>
            <Route path={`${match.url}/payment`} component={asyncComponent(() => import('./routes/Payment'))}/>
            <Route path={`${match.url}/account-receivable`} component={asyncComponent(() => import('./routes/AccountReceivable'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default Finance;


// WEBPACK FOOTER //
// ./app/routes/Finance/index.js